import { ICreateCategoryContext } from './createCategoryContext';

export enum CreateCategoryActionTypes {
	SET_FILE_ID = 'SET_FILE_ID',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	CHANGE_NAME_OF_CATEGORY = 'CHANGE_NAME_OF_CATEGORY',
	SET_CATEGORY_TYPE = 'SET_CATEGORY_TYPE',
	TOGGLE_IS_RESTRICTED = 'TOGGLE_IS_RESTRICTED',
	TOGGLE_HAS_SCHEDULE_PRIORITY = 'TOGGLE_HAS_SCHEDULE_PRIORITY',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_FETCHED_TRANSLATIONS = 'SET_FETCHED_TRANSLATIONS',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetFileId {
	type: CreateCategoryActionTypes.SET_FILE_ID;
	payload: {
		fileId: ICreateCategoryContext['fileId'];
	};
}

interface ISetFetchedCustomers {
	type: CreateCategoryActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: ICreateCategoryContext['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: CreateCategoryActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: ICreateCategoryContext['IDSelectedCustomer'];
	};
}

interface ISetFetchedRestaurants {
	type: CreateCategoryActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: ICreateCategoryContext['fetchedRestaurants'];
	};
}

interface ISetIDsRestaurant {
	type: CreateCategoryActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: ICreateCategoryContext['IDsSelectedRestaurant'];
	};
}

interface IChangeNameOfCategory {
	type: CreateCategoryActionTypes.CHANGE_NAME_OF_CATEGORY;
	payload: {
		nameOfCategory: ICreateCategoryContext['nameOfCategory'];
	};
}

interface ISetCategoryType {
	type: CreateCategoryActionTypes.SET_CATEGORY_TYPE;
	payload: {
		categoryType: ICreateCategoryContext['categoryType'];
	};
}

interface IToggleIsRestricted {
	type: CreateCategoryActionTypes.TOGGLE_IS_RESTRICTED;
}

interface IToggleHasSchedulePriority {
	type: CreateCategoryActionTypes.TOGGLE_HAS_SCHEDULE_PRIORITY;
}

interface IChangeActivationSchedule {
	type: CreateCategoryActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: ICreateCategoryContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: CreateCategoryActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: ICreateCategoryContext['deactivationSchedule'];
	};
}

interface ISetFetchedTranslation {
	type: CreateCategoryActionTypes.SET_FETCHED_TRANSLATIONS;
	payload: {
		translations: ICreateCategoryContext['translations'];
		defaultCustomerLanguage: ICreateCategoryContext['defaultCustomerLanguage'];
	};
}

interface ISetTranslationTab {
	type: CreateCategoryActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: ICreateCategoryContext['selectedTranslationTab'];
	};
}

interface IChangeTranslation {
	type: CreateCategoryActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: ICreateCategoryContext['translations'];
	};
}

interface ISetDataForSubmit {
	type: CreateCategoryActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateCategoryContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ICreateCategoryContext['typeOfModalWindow'];
	};
}

interface IResetSelectedControls {
	type: CreateCategoryActionTypes.RESET_FIELDS;
}

export type TCreateCategoryAction =
	| ISetFileId
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetFetchedRestaurants
	| ISetIDsRestaurant
	| IResetSelectedControls
	| IChangeNameOfCategory
	| ISetCategoryType
	| IToggleIsRestricted
	| IToggleHasSchedulePriority
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetFetchedTranslation
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
